import Link from "next/link";

import { useCertification } from "~/hooks";
import { ACCREDITED_CPT_EXAM_STUDY_PLAN } from "~/lib/accredited-cpt-exam-study-plan";
import NccaAccreditedProgramMark from "~/pages/exam-portal/components/NccaAccreditedProgramMark";

/**
 * Side-by-side Practice Exam and CPT exam accreditation cards.
 * The NCCA mark lives only in the exam card — never in the page header
 * or practice exam card.
 */
const CertificationStudyPlanActionCards = () => {
	const { certification } = useCertification();

	return (
		<div className="mb-6 grid tablet:grid-cols-2 gap-4 tablet:gap-5">
			<article className="flex flex-col gap-4 rounded-2xl border bg-slate-50 p-5 shadow-sm dark:bg-slate-800/60">
				<h2 className="font-semibold text-xl">
					{ACCREDITED_CPT_EXAM_STUDY_PLAN.practiceExamCardTitle}
				</h2>
				<p className="flex-1 laptop:text-base text-sm">
					{ACCREDITED_CPT_EXAM_STUDY_PLAN.practiceExamCardBody}
				</p>
				<Link
					href={`/certifications/${certification.slug}/accredited-practice-exam`}
					className="mt-auto inline-flex max-w-max items-center justify-center rounded-full bg-white px-4 py-2 font-medium shadow shadow-slate-200 hover:bg-slate-100 dark:bg-slate-700 dark:shadow-slate-950 dark:hover:bg-slate-600"
				>
					{ACCREDITED_CPT_EXAM_STUDY_PLAN.practiceExamCardCta}
				</Link>
			</article>

			<article className="flex flex-col items-start gap-4 rounded-2xl border bg-slate-50 p-5 shadow-sm dark:bg-slate-800/60">
				<h2 className="font-semibold text-xl">
					{ACCREDITED_CPT_EXAM_STUDY_PLAN.examBlockTitle}
				</h2>
				<div className="flex w-full items-start gap-3">
					<NccaAccreditedProgramMark size="sm" />
					<p className="min-w-0 flex-1 laptop:text-base text-sm">
						{ACCREDITED_CPT_EXAM_STUDY_PLAN.examDisclaimer}
					</p>
				</div>
				<Link
					href={ACCREDITED_CPT_EXAM_STUDY_PLAN.examPortalHref}
					className="mt-auto inline-flex max-w-max items-center justify-center rounded-full bg-sky-500 px-4 py-2 font-medium text-white shadow shadow-slate-200 hover:bg-sky-600 dark:bg-sky-700 dark:shadow-slate-950"
				>
					{ACCREDITED_CPT_EXAM_STUDY_PLAN.examRegisterLabel}
				</Link>
			</article>
		</div>
	);
};

export default CertificationStudyPlanActionCards;
